<template>
  <div class="container">
    <h2 v-if="article_list_name" class="center-text">{{ article_list_name }}</h2>
    <h2 v-else class="center-text">&nbsp;</h2>

    <!-- Navigation links for sub-pages (grouped) -->
    <nav v-if="article_list_id" class="nav-grouped">

      <!-- コンテンツ管理 -->
      <div class="nav-group">
        <span class="nav-group-label">{{ $t("Articles.nav_group_content") }}</span>
        <div class="nav-group-links">
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/dashboard`">
            {{ $t("Articles.dashboard") }}</router-link>
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/articles`">
            {{ $t("Articles.articles") }}</router-link>
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/futured_medias`">
            {{ $t("Articles.futured_media") }}</router-link>
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/categories`">
            {{ $t("Articles.category") }}</router-link>
        </div>
      </div>

      <!-- 記事生成設定 -->
      <div class="nav-group">
        <span class="nav-group-label">{{ $t("Articles.nav_group_generation") }}</span>
        <div class="nav-group-links">
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/sample_articles`">
            {{ $t("Articles.sample_article") }}</router-link>
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/prompt_templates`">
            {{ $t("Articles.prompt_template") }}</router-link>
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/css_selectors`">
            {{ $t("Articles.css_selector") }}</router-link>
        </div>
      </div>

      <!-- 記事収集 -->
      <div class="nav-group">
        <span class="nav-group-label">{{ $t("Articles.nav_group_collection") }}</span>
        <div class="nav-group-links">
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/crawl_sites`">
            {{ $t("Articles.crawl_sites") }}</router-link>
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/crawl_articles`">
            {{ $t("Articles.crawl_articles") }}</router-link>
        </div>
      </div>

      <!-- 設定・連携 -->
      <div class="nav-group">
        <span class="nav-group-label">{{ $t("Articles.nav_group_settings") }}</span>
        <div class="nav-group-links">
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/connections`">
            {{ $t("Articles.connect_to") }}</router-link>
          <router-link class="nav-link"
                       :to="`/forwriting/article_lists/${article_list_id}/setting`">
            {{ $t("Articles.article_list_setting") }}</router-link>
        </div>
      </div>

    </nav>
    <br>
    <br>

    <!-- Here, the child components will be rendered -->
    <router-view></router-view>
  </div>

</template>

<script>
import {useRoute} from "vue-router";
import {onMounted, ref, watch} from "vue";
import {articleListsApi} from "@/api/forwriting_index";

export default {
  setup() {
    const route = useRoute();
    const article_list_id = ref(null);
    const article_list_name = ref(null);

    const loadArticleListInfo = async (listId) => {
      if (!listId || listId === 'undefined') {
        article_list_id.value = null;
        article_list_name.value = null;
        return;
      }
      
      article_list_id.value = listId;
      // 獲取 article_list 信息以顯示實際名稱
      try {
        const resp = await articleListsApi.get_1(listId);
        article_list_name.value = resp.data.article_list_name;
      } catch (error) {
        console.error("Error fetching article list:", error);
        article_list_name.value = null;
      }
    };

    onMounted(async () => {
      await loadArticleListInfo(route.params.article_list_id);
    });

    // 監聽路由參數變化
    watch(
      () => route.params.article_list_id,
      async (newId) => {
        await loadArticleListInfo(newId);
      }
    );

    return {
      article_list_id,
      article_list_name
    }

  }
}
</script>

<style scoped>
.center-text {
  text-align: center;
}

.nav-grouped {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0;
}

.nav-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  border-right: 1px solid #ddd;
}

.nav-group:last-child {
  border-right: none;
}

.nav-group-label {
  font-size: 0.65rem;
  color: #aaa;
  white-space: nowrap;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
}

.nav-group-links {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-link {
  margin: 0 4px;
  color: #333;
  font-size: 0.85rem;
  white-space: nowrap;
  text-decoration: none;
  padding: 4px 2px;
}

.nav-link:hover {
  color: #0d6efd;
}

.nav-link.router-link-active {
  color: #0d6efd;
  border-bottom: 2px solid #0d6efd;
  font-weight: 500;
}

.container {
  margin-bottom: 100px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* 背景を半透明の黒に */
  z-index: 1000; /* 他の要素より前面に */
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 80%;  /* お好みに合わせて変更 */
  max-width: 500px;  /* お好みに合わせて変更 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal-content button {
  margin-bottom: 10px;  /* ボタンの間隔を追加 */
}
</style>

